import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: ({ props }) => css`
    ${props.contained &&
    css`
      gap: 16px;
      width: 100%;
      max-width: 100%;
    `}
  `,
  dropdown: ({ props }) => css`
    min-width: 250px;
    width: 100%;

    ${props.contained &&
    css`
      gap: 16px;
      width: 100%;
      max-width: 100%;
    `}
  `,
  menu: css`
    width: 435px;
    display: flex;
    flex-direction: column;
    z-index: 3;
    max-height: 100%;
  `,
  inputClosed: ({ theme }) => css`
    color: ${theme.colors.primary.fuchsia[60]};
  `,
  tabs: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 7px 9px 7px 7px;
    height: auto;
    gap: 6px;
    flex: unset;

    border-radius: 12px 12px 0 0;
  `,
  tabsList: css`
    padding-right: 12px;
    margin-bottom: 12px;

    & > button:first-of-type {
      margin-left: 17px;
    }
  `,
  tabsContent: css`
    padding: 0px;
    min-height: 0;
  `,
  messageInfo: css`
    margin: 2px 12px 8px;
  `,
  createJobPill: css`
    display: flex;
    margin-left: auto;
    align-self: center;
    flex-direction: row;
    width: fit-content;
    gap: 8px;

    & > div {
      cursor: pointer;
    }
  `,
  disconnectJobPill: css`
    padding: 2px 4px;
  `,
} satisfies Styles<{ contained: boolean }>;

export const useStyles = withStyles(styles);
